sealed interface Translation {
    val title: String
    val pageNotFound: String
    val articleLabel: String
    val articleHelp: String

    val articlePlaceholder get() = "5C6880741E"

    val tariffRegion: String
    val tariffKind: String
    val validationDate: String

    val submit: String
    val loading: String

    val error: String
    val notFound: String

    val explanation: String
    val alias: String get() = "Alias"
    val descriptions: String
    val hsCode: String
    val validFrom: String
    val validUntil: String

    val redirect: String
    val redirectMessage: String
    val redirectTodo: String

    val help: String
    val helpMessage: String

    val termsOfUse: String
    val legal: String
    val imprint: String
    val dataProtection: String
    val license: String

    object DE : Translation {
        // language=german
        override val title = "Tarifierungsabfrage"
        override val pageNotFound = "Seite nicht gefunden"
        override val articleLabel = "Artikelnummer"
        override val articleHelp = "Die zu überprüfende eindeutige VW-Teilenummer, z.B.: 5C6880741E."
        override val tariffRegion = "Tarifierungsregion"
        override val tariffKind = "Tarifierungsart"
        override val validationDate = "Stichtag"
        override val submit = "Abfrage"
        override val loading = "Lädt"

        override val explanation = "Das System zeigt den derzeit aktuellen Datenstand an und hat keine gesetzliche Verbindlichkeit."
        override val descriptions = "Beschreibungen"
        override val hsCode = "Tarifnummer"
        override val validFrom = "Gültig von"
        override val validUntil = "Gültig bis"

        override val error = "Ein interner Fehler ist aufgetreten"
        override val notFound = "Keine Tarifierung gefunden"

        override val redirect = "Neue Webseite/Link"
        override val redirectMessage = "Die alte Webseite unter https://vocs-tis-prod.vwapps.run ist nicht mehr erreichbar. Es wird nur noch diese neue Webseite https://vocs-tis.vwgroup.com unterstützt."
        override val redirectTodo = "Bitte entferne den alten Link und speichere den neuen Link als Favorit."

        override val help = "Hilfe"
        override val helpMessage = "Bei Fragen wenden Sie sich bitte an den VOCS Support"

        override val termsOfUse = "Nutzungsbedingungen"
        override val legal = "Rechtliche Hinweise"
        override val imprint = "Impressum"
        override val dataProtection = "Datenschutzerklärung"
        override val license = "Lizenzhinweise"
    }

    object EN: Translation {
        override val title = "Tariff Request"
        override val pageNotFound = "Page Not Found"
        override val articleLabel = "Article Number"
        override val articleHelp = "The article number to check, like 5C6880741E"
        override val tariffRegion = "Tariff Region"
        override val tariffKind = "Tariff Kind"
        override val validationDate = "Validation Date"
        override val submit = "Submit"
        override val loading = "Loading"

        override val explanation = "The system displays the current data and has no legal liability."
        override val descriptions = "Descriptions"
        override val hsCode = "HS Code"
        override val validFrom = "Valid From"
        override val validUntil = "Valid Until"

        override val error = "An internal error occurred"
        override val notFound = "No Tariff found"

        override val redirect = "New Website/Link"
        override val redirectMessage = "The old website https://vocs-tis-prod.vwapps.run has been removed. Only the new website is available under https://vocs-tis.vwgroup.com."
        override val redirectTodo = "Please delete the old link and save the new link as favorite."

        override val termsOfUse = "Terms Of Use"
        override val help = "Help"
        override val helpMessage = "Please don't hesitate to ask for support"
        override val legal = "Legal"
        override val imprint = "Imprint"
        override val dataProtection = "Data Protection Declaration"
        override val license = "License Notes"
    }
}
